import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useGlobalModalLaunchContext } from '../../contexts/modal-context/global-modal-context';
import { postWalletRegistrationSuccess } from '../../store/wallet/wallet.actions';
import { useTrackWorkflow, WorkflowSteps } from '../../tracking/use-workflow-tracking';
import { Workflows } from '../../tracking/tracking-constants';
import { ADD_FUNDS_TAB } from '../utilities/constants';
import { useWallet } from './use-wallet';

// General note about this file:
// Centralize behavior here and just consume inside of WalletRegistrationModal and WalletUpdateModal.
// Most of this behavior was shared inside of wallet-registration-or-update-button

// for example of downstream behavior, see postWalletRegistrationSuccessPayload in ss-ui-client/src/wallet/modals/wallet-registration/components/modal-footer/primary-action-button/submit-button.js
export const useOnWalletRegistrationOrUpdateModalClose = (postWalletRegistrationSuccessPayload) => {
  const dispatch = useDispatch();
  const { closeWalletRegistration, closeWalletUpdate } = useGlobalModalLaunchContext();

  const onClose = useCallback(() => {
    dispatch(postWalletRegistrationSuccess(postWalletRegistrationSuccessPayload));
    closeWalletRegistration();
    closeWalletUpdate();
  }, [closeWalletRegistration, closeWalletUpdate, dispatch, postWalletRegistrationSuccessPayload]);

  return onClose;
};

export const useOnWalletRegistrationOrUpdateModalCancel = (walletId) => {
  const { isWalletRegistered } = useWallet(walletId);
  const { currentWalletRegistrationStepId, closeWalletRegistration, closeWalletUpdate } = useGlobalModalLaunchContext();
  const trackWalletRegistration = useTrackWorkflow(Workflows.WALLET_REGISTRATION_FLOW);
  const trackAddFunds = useTrackWorkflow(Workflows.ADD_FUNDS_FLOW);

  const onCancel = useCallback(() => {
    if (currentWalletRegistrationStepId !== ADD_FUNDS_TAB) {
      trackWalletRegistration(WorkflowSteps.CANCEL, {
        wizardStep: currentWalletRegistrationStepId,
        isUpdate: isWalletRegistered,
      });
    }
    if (currentWalletRegistrationStepId === ADD_FUNDS_TAB) {
      trackAddFunds(WorkflowSteps.CANCEL);
    }
    closeWalletRegistration();
    closeWalletUpdate();
  }, [
    closeWalletRegistration,
    closeWalletUpdate,
    currentWalletRegistrationStepId,
    isWalletRegistered,
    trackAddFunds,
    trackWalletRegistration,
  ]);

  return onCancel;
};
